<template>
  <section class="p-2 pt-0">
    <div class="bg-brand/10 rounded-img tablet:py-12">
      <header class="page-container mb-2 laptop:flex">
        <h2 class="section-title mb-6 laptop:w-1/2 text-tertiary font-semibold">
          {{ index.title }}
        </h2>
        <ContentRenderer :value="index" class="text-dark  laptop:w-1/2"/>
      </header>
      <div class="page-container max-tablet:px-2">
        <div class="tablet:flex tablet:justify-between w-full mb-12">
          <div class="tablet:w-1/2 tablet:pe-6 laptop:pe-10 desktop:pe-14 wide:pe-28">
            <ArticleHighlight
                    v-for="entry in entries"
                    :key="entry.path"
                    :title="entry.title"
                    class="bg-brand/20 mb-2 tablet:mb-4 p-6 rounded-img"
                    header-class=""
                    summary-class="text-grey tablet:text-sm"
                    title-class="text-tertiary font-semibold">
              <template #summary>
                <ContentRenderer :value="entry"/>
              </template>
            </ArticleHighlight>
            <ButtonCta
                    v-if="index?.meta?.cta"
                    :cta="index.meta.cta"
                    class="flex tablet:hidden btn-border-green items-center"
            >
              <template #icon-end>
                <ArrowRightIcon class="size-10 ms-2"/>
              </template>
            </ButtonCta>
          </div>
          <div class="tablet:w-1/2">
            <picture class="block">
              <media-source
                      :dimensions="[
                        { width: 1920 },
                        { width: 1280 },
                        { width: 640 }
                      ]"
                      :uri="imgUri"
                      as="source"
                      format="webp"
                      sizes="100vw, (min-width: 768px) 33vw"
              />
              <media-source
                      :alt="index.title"
                      :dimensions="[
                        { width: 1920 },
                        { width: 1280 },
                        { width: 640 }
                      ]"
                      :uri="imgUri"
                      as="img"
                      class-name="w-full h-full object-cover rounded-img aspect-square"
                      format="jpg"
                      sizes="100vw, (min-width: 768px) 33vw"
              />
            </picture>
            <ButtonCta
                    v-if="index?.meta?.cta"
                    :cta="index.meta.cta"
                    class="hidden tablet:flex btn-border-green items-center"
            >
              <template #icon-end>
                <ArrowRightIcon class="size-10 ms-2"/>
              </template>
            </ButtonCta>
          </div>
        </div>
        <div class="tablet:grid tablet:grid-cols-3 px-6 tablet:px-0 tablet:gap-6 laptop:gap-8 desktop:gap-10 wide:gap-12 justify-center">
          <ArticleHighlight
                  v-for="incentive in incentives"
                  :key="incentive.path"
                  :icon-ref="incentive?.meta?.iconRef as string"
                  :title="incentive.title"
                  class="text-tertiary text-center mb-12 tablet:mb-0 tablet:border-brand tablet:border rounded-img tablet:p-6 tablet:flex tablet:items-center tablet:justify-center"
                  header-class=""
                  icon-class="text-brand size-10 mx-auto mb-4"
                  summary-class="text-grey tablet:text-sm"
                  title-class="text-tertiary font-semibold">
          </ArticleHighlight>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import {ArrowRightIcon} from '@heroicons/vue/20/solid';
import type {PageCollectionItemBase} from "@nuxt/content";

const {getIndex, getAllButIndex} = usePage();
const {pages} = defineProps<{
    pages: Array<PageCollectionItemBase>;
}>();
const index = getIndex(pages)!;
const entries = getAllButIndex(pages)!.filter(p => p.path.includes('card_'));
const incentives = getAllButIndex(pages)!.filter(p => p.path.includes('label_'));
const imgUri = computed<string>(() => (index.meta?.imageRef as string || '').replace('/assets', ''));
</script>